import * as actionTypes from './actionTypes';
import LocalStorage from '../../components/Util/LocalStorage/LocalStorage';

const localStorageObject = new LocalStorage();

const initialState = {
    empresa: { Id: 0, Nombre: 'Seleccione una opción' },
    callCenter: { Id: 0, Nombre: 'Seleccione una opción' },
    sucursal: { Id: 0, Nombre: 'Seleccione una opción', Cadena: 0 },
    mapa: { Llave: '', Longitud: '0', Latitud: '0' },
    simboloMoneda: '',
    activoAD:false,
    ...localStorageObject.get("express_web_param") || {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SET_SELECTED_PARAMETERS:
            localStorageObject.set("express_web_param",{
                ...state,
                ...action.playload
            });
            return {
                ...state,
                ...action.payload
            };
        case actionTypes.SET_GOOGLE_KEY_PARAMETER:
            return {
                ...state,
                mapa: { ...state.mapa, Llave: action.payload }
            };
        default:
            return state;
    }
}